module.exports = __webpack_public_path__ + "img/microgaming.c38cd689.png";